(() => {
  if (window.ryppleAccordionEnhance) {
    window.ryppleAccordionEnhance(document);
    return;
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  const selectors = '.rp-mini-accordions details, .rp-mechanism-benefit, .rp-details details, .rp-tech__function';
  const managedProperties = ['height', 'overflow', 'box-sizing', 'padding-top', 'padding-bottom', 'opacity'];

  const enhance = (root) => {
    const candidates = Array.from(root.querySelectorAll(selectors));
    if (root.matches?.(selectors)) candidates.unshift(root);
    candidates.forEach((details) => {
      if (instances.has(details)) return;
      const summary = details.querySelector(':scope > summary');
      const panel = details.querySelector(':scope > div, :scope > p');
      if (!summary || !panel) return;
      const quickAnswer = details.matches('.rp-mini-accordions details');
      const listeners = new AbortController();
      const initialStyles = managedProperties.map((property) => ({
        property,
        value: panel.style.getPropertyValue(property),
        priority: panel.style.getPropertyPriority(property)
      }));
      let animation = null;
      let disposed = false;
      details.dataset.rpAccordionReady = 'true';

      const restoreStyles = () => {
        initialStyles.forEach(({ property, value, priority }) => {
          if (value) panel.style.setProperty(property, value, priority);
          else panel.style.removeProperty(property);
        });
      };
      const settle = (open) => {
        const running = animation;
        animation = null;
        running?.cancel();
        details.open = open;
        restoreStyles();
        details.classList.remove('is-closing');
        delete details.dataset.rpTargetOpen;
      };

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const previousIntent = details.dataset.rpTargetOpen === undefined
          ? details.open
          : details.dataset.rpTargetOpen === 'true';
        const opening = !previousIntent;
        details.dataset.rpTargetOpen = String(opening);

        const style = getComputedStyle(panel);
        const currentHeight = details.open ? panel.getBoundingClientRect().height : 0;
        const currentPaddingTop = details.open ? parseFloat(style.paddingTop) || 0 : 0;
        const currentPaddingBottom = details.open ? parseFloat(style.paddingBottom) || 0 : 0;
        const currentOpacity = quickAnswer && details.open ? Number(style.opacity) : 0;
        const running = animation;
        animation = null;
        running?.cancel();
        restoreStyles();

        if (reduceMotion.matches || typeof panel.animate !== 'function') {
          settle(opening);
          return;
        }

        if (!details.open) details.open = true;
        const naturalStyle = getComputedStyle(panel);
        const fullPaddingTop = parseFloat(naturalStyle.paddingTop) || 0;
        const fullPaddingBottom = parseFloat(naturalStyle.paddingBottom) || 0;
        const fullHeight = panel.getBoundingClientRect().height;
        const targetHeight = opening ? fullHeight : 0;
        details.classList.toggle('is-closing', !opening);

        if (Math.abs(currentHeight - targetHeight) < 1) {
          settle(opening);
          return;
        }

        panel.style.boxSizing = 'border-box';
        panel.style.overflow = 'hidden';
        panel.style.height = `${currentHeight}px`;
        panel.style.paddingTop = `${currentPaddingTop}px`;
        panel.style.paddingBottom = `${currentPaddingBottom}px`;
        const duration = opening
          ? quickAnswer ? 280 : Math.min(340, Math.max(220, Math.abs(targetHeight - currentHeight) * 0.55))
          : quickAnswer ? 220 : Math.min(280, Math.max(180, Math.abs(targetHeight - currentHeight) * 0.45));
        const nextAnimation = panel.animate([
          {
            height: `${currentHeight}px`,
            paddingTop: `${currentPaddingTop}px`,
            paddingBottom: `${currentPaddingBottom}px`,
            ...(quickAnswer ? { opacity: currentOpacity } : {})
          },
          {
            height: `${targetHeight}px`,
            paddingTop: `${opening ? fullPaddingTop : 0}px`,
            paddingBottom: `${opening ? fullPaddingBottom : 0}px`,
            ...(quickAnswer ? { opacity: opening ? 1 : 0 } : {})
          }
        ], { duration, easing: 'cubic-bezier(.22,.68,.22,1)', fill: 'forwards' });
        animation = nextAnimation;
        nextAnimation.onfinish = () => {
          if (disposed || animation !== nextAnimation) return;
          settle(opening);
        };
      }, { signal: listeners.signal });

      const onMotionChange = () => {
        if (!reduceMotion.matches || !animation) return;
        settle(details.dataset.rpTargetOpen === 'true');
      };
      if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', onMotionChange);
      else reduceMotion.addListener?.(onMotionChange);

      instances.set(details, () => {
        if (disposed) return;
        disposed = true;
        settle(details.dataset.rpTargetOpen === undefined ? details.open : details.dataset.rpTargetOpen === 'true');
        listeners.abort();
        if (reduceMotion.removeEventListener) reduceMotion.removeEventListener('change', onMotionChange);
        else reduceMotion.removeListener?.(onMotionChange);
        delete details.dataset.rpAccordionReady;
        instances.delete(details);
      });
    });
  };

  window.ryppleAccordionEnhance = enhance;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(document), { once: true });
  } else enhance(document);
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((cleanup, details) => {
      if (event.target === details || event.target.contains(details)) cleanup();
    });
  });
})();

